import { Base } from "./base";
import { CartonEvents } from "./carton.events";
import { CartonProduct } from "./carton.product";
import { Company } from "./company";
import { Measurement } from "./measurement";
import { Product } from "./product";
import { PurchaseOrder } from "./purchase.order";
import { Shipment } from "./shipments";
import { User } from "./user";

export interface Carton extends Base {
  purchaseOrderId?: number;
  sscc: string;
  type: string;
  unitWeightId?: number;
  uniWeight?: Measurement;
  unitMeasurement?: Measurement;
  company?: Company;
  isClosed?: boolean;
  isReceived?: boolean;
  isReceivedByCfs?: boolean;
  cartonProducts?: CartonProduct[];
  bookedGrossWeight?: number;
  bookedMeasurement?: number;
  cartonQty?: number;
  grossWeight: number;
  measurement?: number;
  isCancelled?: boolean;
  lineId?: number;
  container?: string;
  shipmentContainerInfoId?: number;
  comments?: CartonComment[];
  cartonEvents?: CartonEvents[];
  shipments?: Shipment[];
}

export interface CartonView extends Carton {
  products?: CartonProductView[];
}

export interface CartonProductView extends Omit<Product, "length"> {
  quantityInCarton?: number;
  cartonId?: Carton["id"];
  productId?: Product["id"];
  purchaseOrderId?: CartonProduct["purchaseOrderId"];
  purchaseOrderProductId?: CartonProduct["purchaseOrderProductId"];
  cartonProductId?: CartonProduct["id"];
  poNumber?: PurchaseOrder["reference"];
  cbm?: string | number;
  hsCode?: string;
  commodityCodeId?: number;
  cfsCbm?: number;
  cfsWeight?: number;
  manufactureDetails?: string;
  length?: string;
  gender?: string;
  deletedAt?: string;
  unitOfMeasure?: string;
  originCriterion?: string;
}

export enum CartonType {
  SOLID = "Solid",
  MIXED = "Mix",
}

export interface CartonComment extends Base {
  message?: string;
  user?: User;
  userId?: number;
}
